import { render, staticRenderFns } from "./conversas.vue?vue&type=template&id=7d4d2a6f&scoped=true"
import script from "./conversas.vue?vue&type=script&lang=js"
export * from "./conversas.vue?vue&type=script&lang=js"
import style0 from "./conversas.vue?vue&type=style&index=0&id=7d4d2a6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d4d2a6f",
  null
  
)

export default component.exports